import { render, staticRenderFns } from "./ObsequiosFacturador.vue?vue&type=template&id=6556361f"
import script from "./ObsequiosFacturador.vue?vue&type=script&lang=js"
export * from "./ObsequiosFacturador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports